// extracted by mini-css-extract-plugin
export default {"container":"Styles_container__F1GN-","row":"Styles_row__BjsX6","middleColumn":"Styles_middleColumn__ZssPh","completeColumn":"Styles_completeColumn__ebuYT"};